import * as R from 'ramda';

import {NavigateFunction} from 'react-router-dom';
import {MenuItem} from "primereact/menuitem";
import {PageEntityT} from "../models/pages/pages-provider";

export type NavigatorMenuItemsContext = {
  navigate: NavigateFunction;
  pages: PageEntityT[];
}

const mapPageToMenu = (cfg: {
  page: PageEntityT;
  parentUrl?: string;
  list: PageEntityT[];
  navigate: NavigateFunction;
}): MenuItem => {
  const {
    navigate,
    page,
    parentUrl,
    list,
  } = cfg;
  const currentUrl = parentUrl ? [parentUrl, page.url].join('/') : page.url;
  const items = list
    .filter((itm) => itm.parentId === page.id)
    .sort(orderSorter)
    .map((itm) => mapPageToMenu({
    page: itm,
    list,
    navigate,
    parentUrl: currentUrl,
  }));

  return {
    id: page.url,
    label: page.title,
    ...((items.length === 0 && ((page.hasDocuments || page.hasArticle) || page.isStatic)) ? { command: () => navigate(currentUrl) } : {}),
    ...(items.length > 0 ? { items: [[{ items }]] } : {}),
  }
}

const generatePages = ({navigate, pages}: NavigatorMenuItemsContext): MenuItem[] => {
  return (pages ?? [])
    .filter((page) => R.isNil(page.parentId))
    .sort(orderSorter)
    .map((page) => mapPageToMenu({
        page,
        list: pages,
        navigate,
      }
    ));
}

export const NAVIGATION_ITEMS = ({navigate, pages}: NavigatorMenuItemsContext): MenuItem[] => {
  return generatePages({navigate, pages});
}

const orderSorter = (item1: PageEntityT, item2: PageEntityT) => {
  if (item1.order < item2.order) {
    return -1;
  } else if (item1.order > item2.order) {
    return 1;
  }
  return 0;
}
